import { ReactElement, useEffect, useState } from "react";
import "./ThirdRow.css";
import { Box } from "@mui/material";
import WebIcon from '@mui/icons-material/Web';
import { appRoles } from "../../authConfig";
import { FlexRow } from "../../Common/UI/components/FlexRow";
import useIsAuthorized from "../../Common/UI/hook/useIsAuthorized";
import IntegrationStatuses from "../../Common/UI/components/IntegrationStatuses";
import useUserRoles from "../../Common/UI/hook/useUserRoles";
import { StatusWidget } from "../../Common/UI/components/StatusWidget";
import { AutomatedTestResult } from "./Interfaces";

export const ThirdRow = function ({
  loadingWebsiteTests,
  websiteTests
}: {
  loadingWebsiteTests: boolean;
  websiteTests: AutomatedTestResult[];
}): ReactElement {
  const { roles } = useUserRoles();

  const showIntegration = useIsAuthorized(
    [appRoles.Integration.ViewStatus],
    roles
  );

  const showWebsiteStatus = useIsAuthorized(
    [appRoles.DevDashboard],
    roles
  );
  
  const [websiteStatus, setWebsiteStatus] = useState(false);
  const [automatedTestResults, setAutomatedTestResult] = useState<AutomatedTestResult[]>([]);


  useEffect(() => {
    setWebsiteStatus(loadingWebsiteTests);
  }, [loadingWebsiteTests]);

  useEffect(() => {
    if (!websiteTests || websiteTests === undefined) {
      const defaultWebsiteTests = {
        passed: false,
        runDate: new Date().toISOString()
      } as AutomatedTestResult;
      setAutomatedTestResult([defaultWebsiteTests]);
    } else {
      setAutomatedTestResult(websiteTests);
    }
    setAutomatedTestResult(websiteTests);
  }, [websiteTests]);

  
  return (
    <FlexRow>
      {showWebsiteStatus && <StatusWidget
        data={automatedTestResults}
        isLoading={websiteStatus}
        text="Website Status"
        icon={<WebIcon fontSize="large" />}
        className="website-status-widget"
        lastUpdatedDate={automatedTestResults.map((result) => result.runDate)}
      />}

      {showIntegration && (
        <Box>
          <IntegrationStatuses showDateFilter={false}></IntegrationStatuses>
        </Box>
      )}
    </FlexRow>
  );
};
